import { Component, Inject, OnInit } from '@angular/core';
import { SidePanelRef } from '../../../../shared/features/side-panel/models/side-panel-ref';
import { EditConfirmationPanelComponent } from '../edit-confirmation-panel/edit-confirmation-panel.component';
import { SIDE_PANEL_CONTEXT } from '../../../../shared/features/side-panel/tokens/side-panel.tokens';

@Component({
  selector: 'hub-workspace-edit-resume-panel',
  templateUrl: './edit-resume-panel.component.html',
  styleUrls: ['./edit-resume-panel.component.scss']
})
export class EditResumePanelComponent {

  constructor(@Inject(SIDE_PANEL_CONTEXT) public panelRef: SidePanelRef<{ userId: number; newName: string }>) { }

  goToNextStep(): void {
    const finalPayload = {
      ...this.panelRef.data,
    };
    
    this.panelRef.navigateForward(EditConfirmationPanelComponent, finalPayload);
  }

  goBack(): void {
    this.panelRef.navigateBack();
  }
}
